/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import * as yup from 'yup';

import { COMMON_ERROR_TEXT } from '../../constants/home';
import { parseBool } from '../../utils/utils';

export const viewQuoteYupSchema = yup.object().shape({
  excess: yup.number().required(),
  accidentalDamage: yup.boolean().required(),
  acceptedTermsAndConditions: yup
    .string()
    // eslint-disable-next-line complexity
    .test('acceptedTermsAndConditions', COMMON_ERROR_TEXT, function(
      value: string
    ): boolean {
      if (this.parent.renewal) {
        if (this.parent.autoRenewal) {
          return (
            parseBool(this.parent.claimsConditionTwo) &&
            parseBool(this.parent.claimsConditionOne)
          );
        } else {
          return (
            parseBool(value) &&
            parseBool(this.parent.claimsConditionTwo) &&
            parseBool(this.parent.claimsConditionOne)
          );
        }
      }
      return true;
    }),
  claimsConditionTwo: yup
    .string()
    // eslint-disable-next-line complexity
    .test('claimsConditionTwo', COMMON_ERROR_TEXT, function(
      value: string
    ): boolean {
      if (this.parent.renewal) {
        if (this.parent.autoRenewal) {
          return (
            parseBool(this.parent.claimsConditionTwo) &&
            parseBool(this.parent.claimsConditionOne)
          );
        } else {
          return (
            parseBool(value) &&
            parseBool(this.parent.acceptedTermsAndConditions) &&
            parseBool(this.parent.claimsConditionOne)
          );
        }
      }
      return true;
    }),
  claimsConditionOne: yup
    .string()
    // eslint-disable-next-line complexity
    .test('claimsConditionOne', COMMON_ERROR_TEXT, function(
      value: string
    ): boolean {
      if (this.parent.renewal) {
        if (this.parent.autoRenewal) {
          return (
            parseBool(this.parent.claimsConditionTwo) &&
            parseBool(this.parent.claimsConditionOne)
          );
        } else {
          return (
            parseBool(value) &&
            parseBool(this.parent.claimsConditionTwo) &&
            parseBool(this.parent.acceptedTermsAndConditions)
          );
        }
      }
      return true;
    }),
  insurSmartCheckBox: yup.string().when('insurSmartSwitch', {
    is: true,
    then: yup
      .string()
      .test(
        'insurSmartCheckBox',
        'Please accept',
        (value: boolean) => parseBool(value) === true
      ),
    otherwise: yup.string().notRequired()
  }),
  mortgageApplicationNumber: yup
    .string()
    .nullable()
    .when('insurSmartSwitch', {
      is: true,
      then: yup
        .string()
        .required('Please enter a valid Mortgage Application Number')
        .matches(
          /^[0-9]{7,8}$/,
          'Please enter a valid Mortgage Application Number'
        )
    })
});
